import { func, object } from 'prop-types';
import { path } from 'ramda';
import React from 'react';

import ContentColumns from '../../components/ContentColumns';
import ControlSteps from '../../components/ControlSteps';

const View2 = (_, { fm, formValues, onChange }) => {
  const fatigueSteps = {
    currentStatus: path(['rehab4', 'currentStatus'], formValues),
    clearlyWorseStatus: path(['rehab4', 'clearlyWorseStatus'], formValues),
    nearFutureTarget: path(['rehab4', 'nearFutureTarget'], formValues),
    betterStatus: path(['rehab4', 'betterStatus'], formValues),
    clearlyBetterStatus: path(['rehab4', 'clearlyBetterStatus'], formValues),
  };
  const cognitionSteps = {
    currentStatus: path(['rehab6', 'currentStatus'], formValues),
    clearlyWorseStatus: path(['rehab6', 'clearlyWorseStatus'], formValues),
    nearFutureTarget: path(['rehab6', 'nearFutureTarget'], formValues),
    betterStatus: path(['rehab6', 'betterStatus'], formValues),
    clearlyBetterStatus: path(['rehab6', 'clearlyBetterStatus'], formValues),
  };

  const currentStatusSelected = name => path(['rehab7', name], formValues);

  const onChangeSelected = fieldName => name => {
    onChange({ [fieldName]: name });
  };

  return (
    <React.Fragment>
      <ContentColumns
        firstColumn={
          <div>
            <h2>{fm('onlineRehabilitation.rehab7.2.header')}</h2>
            <br />
            <div>{fm('onlineRehabilitation.rehab7.2.text')}</div>
            <br />
            <h3>{fm('onlineRehabilitation.rehab7.2.fatigue')}</h3>
            <ControlSteps
              steps={fatigueSteps}
              checkedValue={currentStatusSelected('currentFatigueStatusSelected') || 'nothingSelected'}
              onCheck={onChangeSelected('currentFatigueStatusSelected')}
              fm={fm}
            />
            <br />
            <br />
            <h3>{fm('onlineRehabilitation.rehab7.2.cognition')}</h3>
            <ControlSteps
              steps={cognitionSteps}
              checkedValue={currentStatusSelected('currentCognitionStatusSelected') || 'nothingSelected'}
              onCheck={onChangeSelected('currentCognitionStatusSelected')}
              cognition
              fm={fm}
            />
          </div>
        }
      />
    </React.Fragment>
  );
};

View2.contextTypes = {
  fm: func,
  formValues: object,
  onChange: func,
};

export default View2;
